/**
 *   was created by tigran at 05.10.23
 **/

import React, {ChangeEvent, FC} from "react"
import cls from "./atoms.module.scss"
import {ArrowRoundedDown12x7Svg} from "../svg";
import {ComponentNameType} from "../translation_keys/translation_keys_data";
import {TranslationsType} from "../types/homePageTypes";

interface IProps {
    messageId: ComponentNameType
    printedFieldName: string
    selectList: any[]
    name: string
    onChange: (event: ChangeEvent<HTMLSelectElement>) => void
    asterisk?: boolean
    defaultSelected?: string
    disabled?: boolean
    translationsData: TranslationsType;
    fullHeight?: boolean;
    containerHeight?: number
}

export const CustomSelect: FC<IProps> = (
    {
        onChange,
        defaultSelected,
        selectList,
        asterisk = false,
        messageId,
        name,
        printedFieldName,
        translationsData,
        disabled = true,
        fullHeight,
        containerHeight
    }) => {
    const defSelectedAttribute = defaultSelected ? {defaultValue: defaultSelected} : {}
    return (
        <div className={cls.select_wrapper}>
            {
                selectList && selectList.length > 0 &&
                <>
                    <div className={cls.select_label_title}>
                        {translationsData[messageId]}
                        {asterisk && <span className={cls.select_asterisk}> *</span>}
                    </div>
                    <div className={cls.select_container} style={containerHeight ? { height: `${containerHeight}px` } : {}}>
                        <select
                            className={cls.select_width}
                            name={name}
                            onChange={onChange}
                            style={fullHeight ? {height: "100%"} : {}}
                            {...defSelectedAttribute}
                        >
                            <option disabled={disabled}>
                                {translationsData[messageId]}
                            </option>
                            {
                                selectList.map((option: any, index: any) => {
                                    return (
                                        <option
                                            key={index}
                                            value={option[printedFieldName]}
                                        >
                                            {option[printedFieldName]}
                                        </option>
                                    );
                                })
                            }
                        </select>
                        <div className={cls.caret_wrapper}>
                            <ArrowRoundedDown12x7Svg/>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}